// extracted by mini-css-extract-plugin
module.exports = {"container":"wallet-name_container__1lQym","label":"wallet-name_label__1laIR","input":"wallet-name_input__G5za2"};